import React, { useState } from 'react';
import './main.scss';
import homeBannerBottom from '@images/home-banner-bottom.png';
import homeBannerTop from '@images/home-banner-top.png';
import mainLogo from '@images/main-logo.png';
import mainSlogan from '@images/home-m-slogan.png';
import quality1 from '@images/quality1.png';
import quality2 from '@images/quality2.png';
import quality3 from '@images/quality3.png';
import quality4 from '@images/quality4.png';
import ios from '@images/ios.png';
import android from '@images/android.png';
import shadow from '@images/shadow.png';
import shadowM from '@images/img_shadow.png';
import Download from '@modules/Home/Download';
import iosQrcode from '@images/iosQrcode.png';
import androidQrcode from '@images/androidQrcode.png';
import arraw1 from '@/images/arraw1.png'
import { isMobile } from '@/lib/utils';

const AD = [{
    icon: quality1,
    text: '来自欧美商家精选潮品'
}, {
    icon: quality2,
    text: '同步官网价格与折扣'
}, {
    icon: quality3,
    text: '一键直邮，保障正品'
}, {
    icon: quality4,
    text: '机器人下单，安心海外购'
}]

function Main(props: any) {
    const { amount } = props;

    const [current, setCurrent] = useState('IOS')

    return (
        <section className='m-main'>
            <div className='main-image-wrap'>
                <img src={homeBannerBottom} className='bottom-img' />
                <img src={homeBannerTop} className='top-img' />
            </div>
            <div className='right-wrap'>
                <div className='info-wrap'>
                    <img src={mainSlogan} alt="slogan" className='info-wrap-slogan-m' />
                    <div className='info-wrap-slogan'>
                        <img className='logo' src={mainLogo} />
                        <div className='ad-wrap'>
                            {AD.map((item, index) => {
                                return (
                                    <div className='ad-item' key={index}>
                                        <img className='ad-icon' src={item.icon} />
                                        <div className='ad-text'>{item.text}</div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className='button-wrap'>
                        <div className={current === 'IOS' ? 'button iOS-button button-current' : 'button iOS-button'} onMouseMove={() => setCurrent("IOS")}>
                            <img className='icon' src={ios} />
                            <div>iOS下载</div>
                            <Download qrcodeImg={iosQrcode} amount={amount} />
                        </div>
                        <div className={current === 'Android' ? 'button android-button button-current' : 'button android-button'} onMouseMove={() => setCurrent("Android")}>
                            <img className='icon' src={android} />
                            <div>Android下载</div>
                            <Download qrcodeImg={androidQrcode} amount={amount} />
                            <div className='decoration1'></div>
                        </div>
                    </div>
                    <div className='decoration2'></div>
                    <div className='m-button-wrap'>
                        <img src={arraw1} alt="" />
                        <div>下载别样海外购</div>
                    </div>
                </div>
                <img className='shadow' src={isMobile() ? shadowM : shadow} />
            </div>
        </section>
    )
}

export default Main;